import { createSlice } from "@reduxjs/toolkit";
import { initialOverlayState } from "../config/config.overlays";

const overlaySlice = createSlice({
  name: "overlay",
  initialState: initialOverlayState,
  reducers: {
    toggleOverlay(state, action) {
      const { overlayId } = action.payload;
      state[overlayId].active = !state[overlayId].active;
    },
    setIsFetching(state, action) {
      const {overlayId, isFetching} = action.payload;
      state[overlayId].fetching = isFetching;
    },
    setLegendData(state, action) {
      const {overlayId, data} = action.payload;
      state[overlayId].legendData = data;
    }
  },
});

export { overlaySlice };